import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button, Modal, Tabs, Divider, Slider, Space, Card, message, Tooltip } from 'antd';
import Icon from '@components/Icon';
import stores from '@stores';
import { nanoid } from '@utils/utils';

// 贴纸类别和贴纸列表 - 使用在线CDN中的真实贴纸图片
// 类别名称将在组件内通过翻译获取
const stickerCategoriesConfig = [
  {
    key: 'emoji',
    tabKey: 'stickerTool.categories.emoji',
    stickers: [
      { id: 'emoji1', src: 'https://cdn-icons-png.flaticon.com/512/742/742850.png', nameKey: 'stickerTool.stickers.emoji1' },
      { id: 'emoji2', src: 'https://cdn-icons-png.flaticon.com/512/742/742923.png', nameKey: 'stickerTool.stickers.emoji2' },
      { id: 'emoji3', src: 'https://cdn-icons-png.flaticon.com/512/742/742774.png', nameKey: 'stickerTool.stickers.emoji3' },
      { id: 'emoji4', src: 'https://cdn-icons-png.flaticon.com/512/742/742770.png', nameKey: 'stickerTool.stickers.emoji4' },
      { id: 'emoji5', src: 'https://cdn-icons-png.flaticon.com/512/742/742822.png', nameKey: 'stickerTool.stickers.emoji5' },
      { id: 'emoji6', src: 'https://cdn-icons-png.flaticon.com/512/742/742815.png', nameKey: 'stickerTool.stickers.emoji6' },
      { id: 'emoji7', src: 'https://cdn-icons-png.flaticon.com/512/742/742869.png', nameKey: 'stickerTool.stickers.emoji7' },
      { id: 'emoji8', src: 'https://cdn-icons-png.flaticon.com/512/742/742753.png', nameKey: 'stickerTool.stickers.emoji8' },
      { id: 'emoji9', src: 'https://cdn-icons-png.flaticon.com/512/742/742758.png', nameKey: 'stickerTool.stickers.emoji9' },
      { id: 'emoji10', src: 'https://cdn-icons-png.flaticon.com/512/742/742888.png', nameKey: 'stickerTool.stickers.emoji10' },
      { id: 'emoji11', src: 'https://cdn-icons-png.flaticon.com/512/742/742910.png', nameKey: 'stickerTool.stickers.emoji11' },
      { id: 'emoji12', src: 'https://cdn-icons-png.flaticon.com/512/742/742917.png', nameKey: 'stickerTool.stickers.emoji12' }
    ]
  },
  {
    key: 'social',
    tabKey: 'stickerTool.categories.social',
    stickers: [
      { id: 'social1', src: 'https://cdn-icons-png.flaticon.com/512/3128/3128304.png', nameKey: 'stickerTool.stickers.social1' },
      { id: 'social2', src: 'https://cdn-icons-png.flaticon.com/512/3128/3128313.png', nameKey: 'stickerTool.stickers.social2' },
      { id: 'social3', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968764.png', nameKey: 'stickerTool.stickers.social3' },
      { id: 'social4', src: 'https://cdn-icons-png.flaticon.com/512/1384/1384031.png', nameKey: 'stickerTool.stickers.social4' },
      { id: 'social5', src: 'https://cdn-icons-png.flaticon.com/512/889/889102.png', nameKey: 'stickerTool.stickers.social5' },
      { id: 'social6', src: 'https://cdn-icons-png.flaticon.com/512/2504/2504947.png', nameKey: 'stickerTool.stickers.social6' },
      { id: 'social7', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968841.png', nameKey: 'stickerTool.stickers.social7' },
      { id: 'social8', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968793.png', nameKey: 'stickerTool.stickers.social8' },
      { id: 'social9', src: 'https://cdn-icons-png.flaticon.com/512/145/145807.png', nameKey: 'stickerTool.stickers.social9' },
      { id: 'social10', src: 'https://cdn-icons-png.flaticon.com/512/3128/3128219.png', nameKey: 'stickerTool.stickers.social10' },
      { id: 'social11', src: 'https://cdn-icons-png.flaticon.com/512/9868/9868249.png', nameKey: 'stickerTool.stickers.social11' },
      { id: 'social12', src: 'https://cdn-icons-png.flaticon.com/512/1077/1077035.png', nameKey: 'stickerTool.stickers.social12' }
    ]
  },
  {
    key: 'food',
    tabKey: 'stickerTool.categories.food',
    stickers: [
      { id: 'food1', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075977.png', nameKey: 'stickerTool.stickers.food1' },
      { id: 'food2', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075983.png', nameKey: 'stickerTool.stickers.food2' },
      { id: 'food3', src: 'https://cdn-icons-png.flaticon.com/512/2361/2361438.png', nameKey: 'stickerTool.stickers.food3' },
      { id: 'food4', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075929.png', nameKey: 'stickerTool.stickers.food4' },
      { id: 'food5', src: 'https://cdn-icons-png.flaticon.com/512/2965/2965567.png', nameKey: 'stickerTool.stickers.food5' },
      { id: 'food6', src: 'https://cdn-icons-png.flaticon.com/512/3075/3075918.png', nameKey: 'stickerTool.stickers.food6' }
    ]
  },
  {
    key: 'animals',
    tabKey: 'stickerTool.categories.animals',
    stickers: [
      { id: 'animal1', src: 'https://cdn-icons-png.flaticon.com/512/616/616430.png', nameKey: 'stickerTool.stickers.animal1' },
      { id: 'animal2', src: 'https://cdn-icons-png.flaticon.com/512/616/616408.png', nameKey: 'stickerTool.stickers.animal2' },
      { id: 'animal3', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998610.png', nameKey: 'stickerTool.stickers.animal3' },
      { id: 'animal4', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998713.png', nameKey: 'stickerTool.stickers.animal4' },
      { id: 'animal5', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998627.png', nameKey: 'stickerTool.stickers.animal5' },
      { id: 'animal6', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998679.png', nameKey: 'stickerTool.stickers.animal6' }
    ]
  },
  {
    key: 'badges',
    tabKey: 'stickerTool.categories.badges',
    stickers: [
      { id: 'badge1', src: 'https://cdn-icons-png.flaticon.com/512/3176/3176401.png', nameKey: 'stickerTool.stickers.badge1' },
      { id: 'badge2', src: 'https://cdn-icons-png.flaticon.com/512/3800/3800024.png', nameKey: 'stickerTool.stickers.badge2' },
      { id: 'badge3', src: 'https://cdn-icons-png.flaticon.com/512/4254/4254068.png', nameKey: 'stickerTool.stickers.badge3' },
      { id: 'badge4', src: 'https://cdn-icons-png.flaticon.com/512/2643/2643513.png', nameKey: 'stickerTool.stickers.badge4' },
      { id: 'badge5', src: 'https://cdn-icons-png.flaticon.com/512/2799/2799312.png', nameKey: 'stickerTool.stickers.badge5' },
      { id: 'badge6', src: 'https://cdn-icons-png.flaticon.com/512/1647/1647825.png', nameKey: 'stickerTool.stickers.badge6' }
    ]
  },
  {
    key: 'arrows',
    tabKey: 'stickerTool.categories.arrows',
    stickers: [
      { id: 'arrow1', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542617.png', nameKey: 'stickerTool.stickers.arrow1' },
      { id: 'arrow2', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542585.png', nameKey: 'stickerTool.stickers.arrow2' },
      { id: 'arrow3', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542577.png', nameKey: 'stickerTool.stickers.arrow3' },
      { id: 'arrow4', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542605.png', nameKey: 'stickerTool.stickers.arrow4' },
      { id: 'arrow5', src: 'https://cdn-icons-png.flaticon.com/512/8173/8173000.png', nameKey: 'stickerTool.stickers.arrow5' },
      { id: 'arrow6', src: 'https://cdn-icons-png.flaticon.com/512/4542/4542654.png', nameKey: 'stickerTool.stickers.arrow6' }
    ]
  },
  {
    key: 'tech',
    tabKey: 'stickerTool.categories.tech',
    stickers: [
      { id: 'tech1', src: 'https://cdn-icons-png.flaticon.com/512/1055/1055687.png', nameKey: 'stickerTool.stickers.tech1' },
      { id: 'tech2', src: 'https://cdn-icons-png.flaticon.com/512/3174/3174862.png', nameKey: 'stickerTool.stickers.tech2' },
      { id: 'tech3', src: 'https://cdn-icons-png.flaticon.com/512/3659/3659898.png', nameKey: 'stickerTool.stickers.tech3' },
      { id: 'tech4', src: 'https://cdn-icons-png.flaticon.com/512/5968/5968705.png', nameKey: 'stickerTool.stickers.tech4' },
      { id: 'tech5', src: 'https://cdn-icons-png.flaticon.com/512/2721/2721305.png', nameKey: 'stickerTool.stickers.tech5' },
      { id: 'tech6', src: 'https://cdn-icons-png.flaticon.com/512/3178/3178158.png', nameKey: 'stickerTool.stickers.tech6' },
      { id: 'tech7', src: 'https://cdn-icons-png.flaticon.com/512/3247/3247956.png', nameKey: 'stickerTool.stickers.tech7' },
      { id: 'tech8', src: 'https://cdn-icons-png.flaticon.com/512/3616/3616952.png', nameKey: 'stickerTool.stickers.tech8' }
    ]
  },
  {
    key: 'holiday',
    tabKey: 'stickerTool.categories.holiday',
    stickers: [
      { id: 'holiday1', src: 'https://cdn-icons-png.flaticon.com/512/6270/6270077.png', nameKey: 'stickerTool.stickers.holiday1' },
      { id: 'holiday2', src: 'https://cdn-icons-png.flaticon.com/512/3827/3827883.png', nameKey: 'stickerTool.stickers.holiday2' },
      { id: 'holiday3', src: 'https://cdn-icons-png.flaticon.com/512/9381/9381177.png', nameKey: 'stickerTool.stickers.holiday3' },
      { id: 'holiday4', src: 'https://cdn-icons-png.flaticon.com/512/9474/9474449.png', nameKey: 'stickerTool.stickers.holiday4' },
      { id: 'holiday5', src: 'https://cdn-icons-png.flaticon.com/512/5341/5341066.png', nameKey: 'stickerTool.stickers.holiday5' },
      { id: 'holiday6', src: 'https://cdn-icons-png.flaticon.com/512/6020/6020579.png', nameKey: 'stickerTool.stickers.holiday6' },
      { id: 'holiday7', src: 'https://cdn-icons-png.flaticon.com/512/7896/7896624.png', nameKey: 'stickerTool.stickers.holiday7' },
      { id: 'holiday8', src: 'https://cdn-icons-png.flaticon.com/512/2173/2173478.png', nameKey: 'stickerTool.stickers.holiday8' }
    ]
  },
  {
    key: 'travel',
    tabKey: 'stickerTool.categories.travel',
    stickers: [
      { id: 'travel1', src: 'https://cdn-icons-png.flaticon.com/512/3125/3125856.png', nameKey: 'stickerTool.stickers.travel1' },
      { id: 'travel2', src: 'https://cdn-icons-png.flaticon.com/512/9749/9749908.png', nameKey: 'stickerTool.stickers.travel2' },
      { id: 'travel3', src: 'https://cdn-icons-png.flaticon.com/512/9802/9802063.png', nameKey: 'stickerTool.stickers.travel3' },
      { id: 'travel4', src: 'https://cdn-icons-png.flaticon.com/512/10410/10410100.png', nameKey: 'stickerTool.stickers.travel4' },
      { id: 'travel5', src: 'https://cdn-icons-png.flaticon.com/512/819/819560.png', nameKey: 'stickerTool.stickers.travel5' },
      { id: 'travel6', src: 'https://cdn-icons-png.flaticon.com/512/10522/10522640.png', nameKey: 'stickerTool.stickers.travel6' },
      { id: 'travel7', src: 'https://cdn-icons-png.flaticon.com/512/3028/3028283.png', nameKey: 'stickerTool.stickers.travel7' },
      { id: 'travel8', src: 'https://cdn-icons-png.flaticon.com/512/1533/1533105.png', nameKey: 'stickerTool.stickers.travel8' }
    ]
  },
  {
    key: 'fashion',
    tabKey: 'stickerTool.categories.fashion',
    stickers: [
      { id: 'fashion1', src: 'https://cdn-icons-png.flaticon.com/512/2589/2589903.png', nameKey: 'stickerTool.stickers.fashion1' },
      { id: 'fashion2', src: 'https://cdn-icons-png.flaticon.com/512/1785/1785350.png', nameKey: 'stickerTool.stickers.fashion2' },
      { id: 'fashion3', src: 'https://cdn-icons-png.flaticon.com/512/1785/1785378.png', nameKey: 'stickerTool.stickers.fashion3' },
      { id: 'fashion4', src: 'https://cdn-icons-png.flaticon.com/512/1940/1940922.png', nameKey: 'stickerTool.stickers.fashion4' },
      { id: 'fashion5', src: 'https://cdn-icons-png.flaticon.com/512/1150/1150327.png', nameKey: 'stickerTool.stickers.fashion5' },
      { id: 'fashion6', src: 'https://cdn-icons-png.flaticon.com/512/1040/1040254.png', nameKey: 'stickerTool.stickers.fashion6' },
      { id: 'fashion7', src: 'https://cdn-icons-png.flaticon.com/512/1998/1998531.png', nameKey: 'stickerTool.stickers.fashion7' },
      { id: 'fashion8', src: 'https://cdn-icons-png.flaticon.com/512/700/700618.png', nameKey: 'stickerTool.stickers.fashion8' }
    ]
  },
  {
    key: 'business',
    tabKey: 'stickerTool.categories.business',
    stickers: [
      { id: 'business1', src: 'https://cdn-icons-png.flaticon.com/512/3208/3208723.png', nameKey: 'stickerTool.stickers.business1' },
      { id: 'business2', src: 'https://cdn-icons-png.flaticon.com/512/2501/2501143.png', nameKey: 'stickerTool.stickers.business2' },
      { id: 'business3', src: 'https://cdn-icons-png.flaticon.com/512/2541/2541988.png', nameKey: 'stickerTool.stickers.business3' },
      { id: 'business4', src: 'https://cdn-icons-png.flaticon.com/512/3395/3395949.png', nameKey: 'stickerTool.stickers.business4' },
      { id: 'business5', src: 'https://cdn-icons-png.flaticon.com/512/4149/4149679.png', nameKey: 'stickerTool.stickers.business5' },
      { id: 'business6', src: 'https://cdn-icons-png.flaticon.com/512/4300/4300059.png', nameKey: 'stickerTool.stickers.business6' },
      { id: 'business7', src: 'https://cdn-icons-png.flaticon.com/512/3050/3050525.png', nameKey: 'stickerTool.stickers.business7' },
      { id: 'business8', src: 'https://cdn-icons-png.flaticon.com/512/5064/5064074.png', nameKey: 'stickerTool.stickers.business8' }
    ]
  },
  {
    key: 'nature',
    tabKey: 'stickerTool.categories.nature',
    stickers: [
      { id: 'nature1', src: 'https://cdn-icons-png.flaticon.com/512/6115/6115220.png', nameKey: 'stickerTool.stickers.nature1' },
      { id: 'nature2', src: 'https://cdn-icons-png.flaticon.com/512/616/616438.png', nameKey: 'stickerTool.stickers.nature2' },
      { id: 'nature3', src: 'https://cdn-icons-png.flaticon.com/512/4215/4215245.png', nameKey: 'stickerTool.stickers.nature3' },
      { id: 'nature4', src: 'https://cdn-icons-png.flaticon.com/512/4213/4213763.png', nameKey: 'stickerTool.stickers.nature4' },
      { id: 'nature5', src: 'https://cdn-icons-png.flaticon.com/512/4213/4213736.png', nameKey: 'stickerTool.stickers.nature5' },
      { id: 'nature6', src: 'https://cdn-icons-png.flaticon.com/512/2869/2869627.png', nameKey: 'stickerTool.stickers.nature6' },
      { id: 'nature7', src: 'https://cdn-icons-png.flaticon.com/512/1779/1779940.png', nameKey: 'stickerTool.stickers.nature7' },
      { id: 'nature8', src: 'https://cdn-icons-png.flaticon.com/512/1146/1146856.png', nameKey: 'stickerTool.stickers.nature8' },
      { id: 'nature9', src: 'https://cdn-icons-png.flaticon.com/512/2204/2204543.png', nameKey: 'stickerTool.stickers.nature9' },
      { id: 'nature10', src: 'https://cdn-icons-png.flaticon.com/512/2925/2925334.png', nameKey: 'stickerTool.stickers.nature10' },
      { id: 'nature11', src: 'https://cdn-icons-png.flaticon.com/512/3104/3104619.png', nameKey: 'stickerTool.stickers.nature11' },
      { id: 'nature12', src: 'https://cdn-icons-png.flaticon.com/512/2758/2758123.png', nameKey: 'stickerTool.stickers.nature12' }
    ]
  }
];

const StickerTool = observer(() => {
  const { t } = useTranslation('editor');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState('emoji');
  const [stickerScale, setStickerScale] = useState(1);
  const [stickerRotation, setStickerRotation] = useState(0);
  const [previewSticker, setPreviewSticker] = useState(null);
  
  // 打开贴纸选择器
  const showStickerModal = () => {
    if (!stores.editor.isEditing) {
      message.info(t('stickerTool.pleaseAddImage'));
      return;
    }
    setIsModalOpen(true);
  };
  
  // 关闭贴纸选择器
  const handleCancel = () => {
    setIsModalOpen(false);
    setPreviewSticker(null);
  };
  
  // 预览贴纸
  const handleStickerHover = (sticker) => {
    setPreviewSticker(sticker);
  };
  
  // 重置预览
  const handleStickerLeave = () => {
    setPreviewSticker(null);
  };
  
  // 添加贴纸到画布
  const addStickerToCanvas = (sticker) => {
    if (!stores.editor.isEditing) return;
    
    // 计算画布中心位置
    const frameBox = stores.editor.app.editor.parent.children.find(child => child.tag === 'framebox');
    const centerX = frameBox ? frameBox.width / 2 : stores.option.frameConf.width / 2;
    const centerY = frameBox ? frameBox.height / 2 : stores.option.frameConf.height / 2;
    
    // 添加贴纸
    stores.editor.addShape({
      id: nanoid(),
      type: 'image',
      src: sticker.src,
      zIndex: stores.editor.shapes.size + 1,
      x: centerX - 40,
      y: centerY - 40,
      width: 80 * stickerScale,
      height: 80 * stickerScale,
      rotation: stickerRotation,
      editable: true
    });
    
    // 关闭模态框
    setIsModalOpen(false);
    setPreviewSticker(null);
    
    // 显示成功消息
    message.success(t('stickerTool.stickerAdded', { name: t(sticker.nameKey) }));
    
    // 重置工具状态
    stores.editor.setUseTool(null);
  };
  
  // 获取当前类别的所有贴纸
  const getCurrentCategoryStickers = () => {
    const category = stickerCategoriesConfig.find(cat => cat.key === currentCategory);
    return category ? category.stickers : [];
  };
  
  return (
    <>
      <Button
        type="text"
        className="w-full flex items-center justify-start rounded-md px-2 py-1 h-auto hover:bg-purple-50 dark:hover:bg-gray-800 hover:text-purple-600 dark:hover:text-purple-400"
        onClick={showStickerModal}
      >
        <Icon.Sticker size={18} useFa={true} className="mr-2" />
        <span className="text-xs">{t('stickerTool.addSticker')}</span>
      </Button>
      
      <Modal
        title={
          <div className="flex items-center text-purple-600 dark:text-purple-400">
            <Icon.Sticker size={20} useFa={true} className="mr-2" />
            <span>{t('stickerTool.addSticker')}</span>
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={720}
        className="sticker-modal"
        maskStyle={{ background: 'rgba(0, 0, 0, 0.45)' }}
        bodyStyle={{ padding: "16px", background: stores.editor.isDark ? "#1f2937" : "#f8fafc" }}
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm mb-4">
              <Divider orientation="left" orientationMargin="0" className="text-xs text-gray-500 dark:text-gray-400 my-1">
                <div className="flex items-center">
                  <Icon.Sliders size={12} useFa={true} className="mr-1 text-purple-500 dark:text-purple-400" />
                  <span>{t('stickerTool.stickerSettings')}</span>
                </div>
              </Divider>
              
              <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs">{t('stickerTool.scale')}</span>
                  <span className="text-xs text-gray-500">{stickerScale.toFixed(1)}x</span>
                </div>
                <Slider
                  min={0.5}
                  max={3}
                  step={0.1}
                  value={stickerScale}
                  onChange={setStickerScale}
                />
              </div>
              
              <div className="mb-2">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs">{t('stickerTool.rotation')}</span>
                  <span className="text-xs text-gray-500">{stickerRotation}°</span>
                </div>
                <Slider
                  min={-180}
                  max={180}
                  value={stickerRotation}
                  onChange={setStickerRotation}
                />
              </div>
            </div>
            
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm">
              <Divider orientation="left" orientationMargin="0" className="text-xs text-gray-500 dark:text-gray-400 my-1">
                <div className="flex items-center">
                  <Icon.Sticker size={12} useFa={true} className="mr-1 text-purple-500 dark:text-purple-400" />
                  <span>{t('stickerTool.selectSticker')}</span>
                </div>
              </Divider>
              
              <Tabs 
                activeKey={currentCategory}
                onChange={setCurrentCategory}
                className="sticker-tabs"
                items={stickerCategoriesConfig.map(category => ({
                  key: category.key,
                  label: t(category.tabKey),
                  children: (
                    <div className="grid grid-cols-3 md:grid-cols-4 gap-3 p-2">
                      {category.stickers.map(sticker => (
                        <Tooltip 
                          key={sticker.id} 
                          title={t(sticker.nameKey)}
                          mouseEnterDelay={0.5}
                        >
                          <Card
                            hoverable
                            className="flex flex-col justify-center items-center p-1 cursor-pointer hover:border-purple-500 dark:hover:border-purple-400"
                            onClick={() => addStickerToCanvas(sticker)}
                            onMouseEnter={() => handleStickerHover(sticker)}
                            onMouseLeave={handleStickerLeave}
                            bordered
                          >
                            <div className="w-full h-16 flex items-center justify-center">
                              <img 
                                src={sticker.src} 
                                alt={t(sticker.nameKey)} 
                                className="max-w-full max-h-full object-contain"
                              />
                            </div>
                            <div className="mt-1 text-xs truncate w-full text-center">{t(sticker.nameKey)}</div>
                          </Card>
                        </Tooltip>
                      ))}
                    </div>
                  )
                }))}
              />
            </div>
          </div>
          
          <div className="hidden md:block">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm h-full">
              <Divider orientation="left" orientationMargin="0" className="text-xs text-gray-500 dark:text-gray-400 my-1">
                <div className="flex items-center">
                  <Icon.ZoomIn size={12} className="mr-1 text-purple-500 dark:text-purple-400" />
                  <span>{t('stickerTool.preview')}</span>
                </div>
              </Divider>
              
              <div className="sticker-preview-container p-4 flex flex-col items-center justify-center h-[calc(100%-40px)]">
                <div className="sticker-preview flex-1 flex items-center justify-center w-full">
                  {previewSticker ? (
                    <img 
                      src={previewSticker.src} 
                      alt={t(previewSticker.nameKey)}
                      style={{ 
                        transform: `scale(${stickerScale}) rotate(${stickerRotation}deg)`,
                        maxWidth: '80%',
                        maxHeight: '80%'
                      }}
                    />
                  ) : (
                    <div className="text-center text-gray-400 dark:text-gray-500">
                      <Icon.Sticker size={48} useFa={true} className="mb-2 opacity-50" />
                      <p className="text-sm">{t('stickerTool.hoverToPreview')}</p>
                    </div>
                  )}
                </div>
                
                {previewSticker && (
                  <Button 
                    type="primary" 
                    className="mt-4 bg-purple-600 hover:bg-purple-700 border-purple-600"
                    onClick={() => addStickerToCanvas(previewSticker)}
                  >
                    {t('stickerTool.addToCanvas')}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default StickerTool; 